import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { EmailsInput } from '@/components/ui/EmailsInput';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

const SplitNotificationsEmailsCash = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreference = useAppSelector(getUserPreferences);

  const handleChange = (splitNotificationsEmailsCash: string[]) => {
    updateUserPreferences({ ...userPreference, splitNotificationsEmailsCash });
  };

  return (
    <div>
      <p className="mt-2 mb-2">
        <FormattedMessage id="userPreferences.section.SplitNotificationsEmailsCash" />
      </p>
      <EmailsInput
        emails={userPreference.splitNotificationsEmailsCash}
        onChange={handleChange}
        dataE2e="user-preferences-notifications-emails-for-cash"
      />
    </div>
  );
};

export default SplitNotificationsEmailsCash;
